package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class Contact(
  public val id: Long,
  public val _id: String?,
  public val name: String?,
  public val contactType: String?,
  public val industry: String?,
  public val address: String?,
  public val email: String?,
  public val phone: String?,
  public val personName: String?,
  public val personEmail: String?,
  public val personAddress: String?,
  public val personPhone: String?,
  public val workspaceId: String?,
)
